import { CheckCircle } from '@mui/icons-material'
import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
  useTheme,
} from '@mui/material'

import logoWhite from '~/assets/images/corp/logo-white.svg'
import heyLibbyCapabilities from '~/layouts/auth/utils'
import rem from '~/utils/ui'

function ReplifyAuthFeaturesPanel() {
  const theme = useTheme()

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: theme.palette.menuBackground,
        width: '100%',
        color: theme.palette.common.white,
        overflow: 'auto',
      }}
    >
      <Stack
        sx={{
          width: '100%',
          maxWidth: rem(400),
          p: { xxxs: 4, md: 0 },
          gap: { xxxs: 4, md: 3 },
        }}
      >
        <Stack
          sx={{
            alignItems: 'center',
            gap: { xxxs: 3, md: 4 },
            minWidth: rem(200),
          }}
        >
          <Box
            component="img"
            src={logoWhite}
            alt="Replify"
            sx={{
              height: { xxxs: rem(50), md: rem(70) },
            }}
          />
          <Typography
            component="h2"
            sx={{
              textAlign: 'center',
              fontWeight: theme.typography.fontWeightBold,
              fontSize: { xxxs: rem(24), md: rem(36) },
              lineHeight: 1.2,
              letterSpacing: rem(2),
            }}
          >
            Login to access these great features
          </Typography>
        </Stack>
        <Box sx={{ minWidth: rem(200) }}>
          <List>
            {heyLibbyCapabilities.map((capability) => (
              <ListItem
                disablePadding
                key={capability}
                sx={{
                  my: 2,
                  '& .MuiListItemIcon-root': {
                    minWidth: rem(32),
                  },
                }}
              >
                <ListItemIcon sx={{ color: theme.palette.primary1 }}>
                  <CheckCircle />
                </ListItemIcon>
                <ListItemText primary={capability} />
              </ListItem>
            ))}
          </List>
        </Box>
      </Stack>
    </Box>
  )
}

export default ReplifyAuthFeaturesPanel
